import { CustomersContainer } from 'components/seller/customers/Customers/CustomersContainer';

function Customers() {
  return <CustomersContainer />;
}

export default Customers;
